import './program.component.scss'

import $ from 'jquery'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

$(document).ready(function () {
  $('[data-popup-link="programs-form"]').click(function (e) {
    const id = $(this).data('open-popup');
    const target = $(`.popup[data-popup=${id}]`);
    const addons = $('form .addons');
    const programId = $(this).parents('.programs-features__card').data('program');
    const price = parseFloat($(this).parents('.programs-features__card').find('.programs-features__price span').text().replace('$', '').replace(',', ''));
    addons.show()
    $('[data-price-render]').text('$' + price);
    $('[data-program-selector]').val(programId);
    if (programId === 3) {
      addons.hide()
    }
    $('[data-render-program]').text($('[data-program-selector]').find('option:selected').text());
    window.signUp.changeStep(0);
    if (target.length > 0) {
      e.preventDefault();
      target.addClass('popup--show');
      disableBodyScroll(target.find('.popup__content')[0]);
      $('body').addClass('blured');
    }


    $('.input_addons').each(function(){
      $(this).prop('checked', false);
    });
    
    $('.input_addons').click(function () {
      let addons_price = 0
      $('.input_addons:checked').each(function(){
        addons_price = parseInt(addons_price) + parseInt($(this).val())
      });
      const new_price = price + addons_price
      $('[data-price-render]').text('$' + new_price);
    })

  });

  $('.popup__close').click(function () {
    $(this).parents('.popup').removeClass('popup--show');
    $('body').removeClass('blured');
    clearAllBodyScrollLocks();
  });
  $('.program-item__expand').click(function () {
    const target = $(this).parents('.program-item').find('.program-item__text');
    if (target.hasClass('program-item__text--show')) {
      target.removeClass('program-item__text--show');
      target.find('.hidden').slideUp(250);
      $(this).text('expand description');
    } else {
      target.addClass('program-item__text--show');
      target.find('.hidden').slideDown(250);
      $(this).text('hide description');
    }
  });

  function fixItems() {
    let maxHeight = 0;
    let offset = 0;
    $('.program-item').each(function () {
      if ($(this).height() > maxHeight) {
        offset = parseInt($(this).css('padding-top')) + parseInt($(this).css('padding-bottom'));
        maxHeight = $(this).height();
      }
    });
    $('.program-item').css('min-height', maxHeight + offset);
  }
  fixItems();

  $(window).resize(function () {
    fixItems();
  });

})